import { useEffect } from 'react'
import { connectorLocalStorageKey, ConnectorNames } from 'toonswap-uikit'
import useAuth from 'hooks/useAuth'
import {
  metamaskConnection,
  walletConnectConnection,
  okxWalletConnection,
  starKeyConnection,
  trustWalletConnection,
} from 'connectors'

const useEagerConnect = () => {
  const { login } = useAuth()

  const tryConnect = async (selectedConnection: any) => {
    if (!selectedConnection) {
      return
    }

    if (selectedConnection?.connectEagerly) {
      await selectedConnection.connectEagerly()
    } else {
      await selectedConnection.activate()
    }
  }

  useEffect(() => {
    const connectorId = window.localStorage.getItem(connectorLocalStorageKey) as ConnectorNames

    // Disable eager connect for Core Chain Wallet. Currently the Core Chain Wallet extension does not inject BinanceChain
    // into the Window object in time causing it to throw an error
    // TODO: Figure out an elegant way to listen for when the BinanceChain object is ready
    // if (connectorId) {
    //   login(connectorId)
    // }
    let selectedConnection: any
    if (connectorId === ConnectorNames.Injected) {
      selectedConnection = metamaskConnection
    } else if (connectorId === ConnectorNames.WalletConnect) {
      selectedConnection = walletConnectConnection
    } else if (connectorId === ConnectorNames.OkxWallet) {
      selectedConnection = okxWalletConnection
    } else if (connectorId === ConnectorNames.Starkey) {
      selectedConnection = starKeyConnection
    } else if (connectorId === ConnectorNames.TrustWallet) {
      selectedConnection = trustWalletConnection
    }

    tryConnect(selectedConnection?.connector)
  }, [login])
}

export default useEagerConnect
